import React from 'react';

import { MDText } from 'i18n-react';

import LocalTexts from '../../../Payments.text.json';
import { FiguresBoxProps } from '../FiguresBox';
import { FiguresBoxLoader } from '../FiguresBoxLoader/FiguresBoxLoader';

import styles from './FigureBoxLoaderText.scss';

interface FiguresBoxLoaderTextProps extends FiguresBoxProps {
  description?: string | any;
  title?: string | any;
}

const LocalT = new MDText(LocalTexts.payments.pendingView);

const FigureBoxLoaderText = ({
  description = `${LocalT.translate('desc')}`,
  title = `${LocalT.translate('titleNotPayment')}`,
}: FiguresBoxLoaderTextProps) => (
  <div className={styles.titleBox}>
    <FiguresBoxLoader label={title} />
    <hr />
    <div className={styles.description} data-testid="description">
      {description}
    </div>
  </div>
);

export { FigureBoxLoaderText };
